import { render, staticRenderFns } from "./Disclosure.vue?vue&type=template&id=5ab3450a&scoped=true&"
import script from "./Disclosure.vue?vue&type=script&lang=js&"
export * from "./Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./Disclosure.vue?vue&type=style&index=0&id=5ab3450a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab3450a",
  null
  
)

export default component.exports